<template>
	<div class="app-content ap dashboard">
		<div class="row mb-4">
			<div class="col">
				<div class="d-flex h-100 w-100 align-items-center">
					<h1 class="ap__main-title">Hello {{ user.username }} - <span>TEXT SEARCH & CLASSIFICATION</span></h1>
				</div>
			</div>
			<div class="col-auto">
				<router-link to="/search" class="btn btn-primary">New Search</router-link>
			</div>
		</div>
		<div class="row mb-4">
			<div class="col-lg-4">
				<div class="content-block">
					<div class="content-block__header row">
						<div class="content-block__title col">Workspace</div>
						<div class="content-block__actions col-auto">
							<ul>
								<li>
									<button class="dashboard__button dashboard__new-folder" @click="createFolder" title="Add folder"><svg viewBox="0 0 512 512"><path d="M394.667,256c-64.698,0-117.333,52.635-117.333,117.333s52.635,117.333,117.333,117.333S512,438.031,512,373.333S459.365,256,394.667,256z M437.333,384h-32v32c0,5.896-4.771,10.667-10.667,10.667S384,421.896,384,416v-32h-32c-5.896,0-10.667-4.771-10.667-10.667c0-5.896,4.771-10.667,10.667-10.667h32v-32c0-5.896,4.771-10.667,10.667-10.667s10.667,4.771,10.667,10.667v32h32c5.896,0,10.667,4.771,10.667,10.667C448,379.229,443.229,384,437.333,384z"/><path d="M256,373.333c0-76.458,62.208-138.667,138.667-138.667c20.563,0,40.552,4.552,59.417,13.531c3.323,1.563,7.198,1.333,10.281-0.615c3.094-1.958,4.969-5.365,4.969-9.021V106.667c0-23.531-19.135-42.667-42.667-42.667h-198.25l-39.542-39.542c-2-2-4.708-3.125-7.542-3.125H42.667C19.135,21.333,0,40.469,0,64v298.667c0,23.531,19.135,42.667,42.667,42.667h204.365c3.094,0,6.031-1.344,8.063-3.677c2.021-2.333,2.938-5.438,2.5-8.5C256.51,385.573,256,379.271,256,373.333z"/></svg></button>
								</li>
								<li>
									<button class="dashboard__button dashboard__to-trash" @click="goToFolderTrash" title="Go to folder trash"><svg viewBox="0 0 480.052 480.052"><path d="M435.498,64.829c-2.248-1.089-4.876-1.066-7.105,0.064l-34.48,17.488l-26.984-46.352c-9.237-17.313-27.298-28.091-46.92-28H186.665c-19.909,0.048-38.353,10.472-48.664,27.504l-24.8,40.304c-2.292,3.724-1.17,8.598,2.52,10.944l88,56c1.282,0.815,2.769,1.247,4.288,1.248c0.664,0.001,1.325-0.083,1.968-0.248c2.135-0.541,3.953-1.939,5.024-3.864l33.6-60.456l36.8,69.6l-33.504,20.104c-2.942,1.764-4.432,5.208-3.704,8.56c0.725,3.351,3.505,5.867,6.912,6.256l119.064,13.536c0.3,0.032,0.602,0.048,0.904,0.048c3.066,0,5.863-1.752,7.2-4.512l56.936-117.536C441.135,71.54,439.474,66.755,435.498,64.829z M205.137,124.716l-74.184-47.2l20.72-33.664c7.401-12.267,20.666-19.782,34.992-19.824h32.48l19.824,39.8L205.137,124.716z M370.345,180.98l-89.984-10.232l19.768-11.864c3.639-2.188,4.935-6.837,2.952-10.592L237.377,24.028h82.632c13.895-0.02,26.648,7.688,33.088,20l30.784,52.904c2.137,3.656,6.752,5.013,10.528,3.096l20.048-10.16L370.345,180.98z"/><path d="M473.049,232.06l-25.856-51.648c-1.974-3.953-6.779-5.556-10.732-3.582c-0.159,0.079-0.315,0.164-0.468,0.254l-96,56c-3.762,2.194-5.077,6.994-2.96,10.8l33.376,60.144h-74.4v-32c0.002-4.418-3.579-8.001-7.997-8.003c-2.255-0.001-4.406,0.95-5.923,2.619l-80,88c-2.607,2.869-2.782,7.194-0.416,10.264l80,104c2.697,3.499,7.721,4.149,11.22,1.452c1.964-1.514,3.115-3.852,3.116-6.332v-24h56c19.726,0.486,37.977-10.407,46.912-28l56-95.952l16.64-26.88C482.324,271.813,482.893,249.98,473.049,232.06z M385.009,404.156c-6.164,12.51-19.059,20.275-33,19.872h-64c-4.418,0-8,3.582-8,8v8.48l-61.6-80.048l61.6-67.744v19.312c0,4.418,3.582,8,8,8h146.072L385.009,404.156z M457.921,280.812l-14.4,23.2h-54.808l-33.904-61.016l81.864-47.768l22.2,44.32C466.039,252.463,465.675,268.241,457.921,280.812z"/><path d="M191.273,244.676l-48-104c-1.38-3.006-4.467-4.854-7.768-4.648l-128,8c-4.41,0.274-7.763,4.07-7.489,8.48c0.161,2.588,1.565,4.938,3.769,6.304l0.008,0.016l39.552,24.528l-26.4,52.864c-9.569,17.385-9.514,38.472,0.144,55.808l44.52,76.88l24.344,42.168c10.455,17.76,29.448,28.746,50.056,28.952h32c4.418,0,8-3.582,8-8v-112c0-4.418-3.582-8-8-8h-59.768l39.904-69.24l32.992,12.704c4.124,1.585,8.753-0.473,10.338-4.597C192.25,248.88,192.177,246.637,191.273,244.676z M160.009,328.028v96h-24c-14.908-0.144-28.651-8.089-36.216-20.936l-21.96-38.048l22.656-37.016H160.009z M147.505,225.396c-3.676-1.412-7.833,0.06-9.8,3.472l-69.2,120.064l-37.568-64.904c-6.906-12.618-6.803-27.908,0.272-40.432l29.752-59.632c1.863-3.706,0.585-8.221-2.944-10.4l-24.472-15.136l97.496-6.072l37.44,81.12L147.505,225.396z"/></svg></button>
								</li>
							</ul>
						</div>
					</div>
					<div class="content-block__body">

						<Folder
							v-for="folder in folders"
							:folder="folder"
							:key="folder.folder_slug"
							@clicked="getNotes(folder)"
						/>

					</div>
				</div>
			</div>
			<div class="col-lg-8">
				<div class="content-block" v-if="currentFolder">
					<div class="content-block__header row">
						<div class="content-block__title col">{{ currentFolder.folder_title }}</div>
						<div class="content-block__actions col-auto">
							<ul>
								<!--<li>
									<button class="dashboard__button dashboard__delete-notes mr-3" @click="deleteNotes" title="Delete selected notes"><svg viewBox="0 0 515.556 515.556"><path d="m64.444 451.111c0 35.526 28.902 64.444 64.444 64.444h257.778c35.542 0 64.444-28.918 64.444-64.444v-322.222h-386.666z"/><path d="m322.222 32.222v-32.222h-128.889v32.222h-161.111v64.444h451.111v-64.444z"/></svg></button>
								</li>-->
								<li>
									<button class="dashboard__button dashboard__create-note" @click="createNote()" title="Create note"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m108.913.1-63.536 63.535h63.536z"/><path d="m280.191 325.469c23.957-23.957 55.81-37.151 89.69-37.151 2.103 0 4.199.051 6.285.152v-288.47h-237.253v93.635h-93.635v343.163h199.592c-1.21-7.079-1.83-14.311-1.83-21.639 0-33.88 13.194-65.733 37.151-89.69zm-173.125-193.1h207.313v30h-207.313zm0 63.735h207.313v30h-207.313zm0 63.734h207.313v30h-207.313z"/><path d="m438.358 346.682c-37.819-37.819-99.135-37.819-136.954 0s-37.819 99.135 0 136.954 99.135 37.819 136.954 0 37.819-99.135 0-136.954zm-25.958 83.477h-27.519v27.518h-30v-27.518h-27.518v-30h27.518v-27.519h30v27.519h27.519z"/></svg></button>
								</li>
								<li>
									<button class="dashboard__button dashboard__to-trash" @click="goToNoteTrash" title="Go to note trash"><svg viewBox="0 0 480.052 480.052"><path d="M435.498,64.829c-2.248-1.089-4.876-1.066-7.105,0.064l-34.48,17.488l-26.984-46.352c-9.237-17.313-27.298-28.091-46.92-28H186.665c-19.909,0.048-38.353,10.472-48.664,27.504l-24.8,40.304c-2.292,3.724-1.17,8.598,2.52,10.944l88,56c1.282,0.815,2.769,1.247,4.288,1.248c0.664,0.001,1.325-0.083,1.968-0.248c2.135-0.541,3.953-1.939,5.024-3.864l33.6-60.456l36.8,69.6l-33.504,20.104c-2.942,1.764-4.432,5.208-3.704,8.56c0.725,3.351,3.505,5.867,6.912,6.256l119.064,13.536c0.3,0.032,0.602,0.048,0.904,0.048c3.066,0,5.863-1.752,7.2-4.512l56.936-117.536C441.135,71.54,439.474,66.755,435.498,64.829z M205.137,124.716l-74.184-47.2l20.72-33.664c7.401-12.267,20.666-19.782,34.992-19.824h32.48l19.824,39.8L205.137,124.716z M370.345,180.98l-89.984-10.232l19.768-11.864c3.639-2.188,4.935-6.837,2.952-10.592L237.377,24.028h82.632c13.895-0.02,26.648,7.688,33.088,20l30.784,52.904c2.137,3.656,6.752,5.013,10.528,3.096l20.048-10.16L370.345,180.98z"/><path d="M473.049,232.06l-25.856-51.648c-1.974-3.953-6.779-5.556-10.732-3.582c-0.159,0.079-0.315,0.164-0.468,0.254l-96,56c-3.762,2.194-5.077,6.994-2.96,10.8l33.376,60.144h-74.4v-32c0.002-4.418-3.579-8.001-7.997-8.003c-2.255-0.001-4.406,0.95-5.923,2.619l-80,88c-2.607,2.869-2.782,7.194-0.416,10.264l80,104c2.697,3.499,7.721,4.149,11.22,1.452c1.964-1.514,3.115-3.852,3.116-6.332v-24h56c19.726,0.486,37.977-10.407,46.912-28l56-95.952l16.64-26.88C482.324,271.813,482.893,249.98,473.049,232.06z M385.009,404.156c-6.164,12.51-19.059,20.275-33,19.872h-64c-4.418,0-8,3.582-8,8v8.48l-61.6-80.048l61.6-67.744v19.312c0,4.418,3.582,8,8,8h146.072L385.009,404.156z M457.921,280.812l-14.4,23.2h-54.808l-33.904-61.016l81.864-47.768l22.2,44.32C466.039,252.463,465.675,268.241,457.921,280.812z"/><path d="M191.273,244.676l-48-104c-1.38-3.006-4.467-4.854-7.768-4.648l-128,8c-4.41,0.274-7.763,4.07-7.489,8.48c0.161,2.588,1.565,4.938,3.769,6.304l0.008,0.016l39.552,24.528l-26.4,52.864c-9.569,17.385-9.514,38.472,0.144,55.808l44.52,76.88l24.344,42.168c10.455,17.76,29.448,28.746,50.056,28.952h32c4.418,0,8-3.582,8-8v-112c0-4.418-3.582-8-8-8h-59.768l39.904-69.24l32.992,12.704c4.124,1.585,8.753-0.473,10.338-4.597C192.25,248.88,192.177,246.637,191.273,244.676z M160.009,328.028v96h-24c-14.908-0.144-28.651-8.089-36.216-20.936l-21.96-38.048l22.656-37.016H160.009z M147.505,225.396c-3.676-1.412-7.833,0.06-9.8,3.472l-69.2,120.064l-37.568-64.904c-6.906-12.618-6.803-27.908,0.272-40.432l29.752-59.632c1.863-3.706,0.585-8.221-2.944-10.4l-24.472-15.136l97.496-6.072l37.44,81.12L147.505,225.396z"/></svg></button>
								</li>
							</ul>
						</div>
					</div>
					<div class="content-block__body">
						<table class="table dashboard__note-table">
							<thead>
								<tr>
									<!--<th scope="col"><input type="checkbox" v-model="selectAllNotes"></th>-->
									<th scope="col">Name</th>
									<th scope="col">Created</th>
									<th scope="col">Updated</th>
									<th scope="col">Taxonomy</th>
									<th scope="col" class="text-center">Actions</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="note in notes" :key="note.note_slug">
									<!--<th scope="row"><input type="checkbox" name="selectedNotes" :value="note" v-model="selectedNotes"></th>-->
									<td class="dashboard__note-name">{{ note.note_title }}</td>
									<td>{{ note.created_at | moment('YYYY-MM-DD') }}</td>
									<td>{{ note.updated_at | moment('YYYY-MM-DD') }}</td>
									<td>
										<template v-if="note.taxonomies.length">
											<span v-b-popover.hover.bottom="getMoreTaxonomiesLabels(note)">{{ getTaxonomyLabel(note.taxonomies[0]) }}</span>
										</template>
									</td>
									<td class="text-center">
										<button class="dashboard__view-note mr-3" @click="goToNote(note)" title="View note"><svg viewBox="0 0 469.333 469.333"><path d="M234.667,170.667c-35.307,0-64,28.693-64,64s28.693,64,64,64s64-28.693,64-64S269.973,170.667,234.667,170.667z"/><path d="M234.667,74.667C128,74.667,36.907,141.013,0,234.667c36.907,93.653,128,160,234.667,160c106.773,0,197.76-66.347,234.667-160C432.427,141.013,341.44,74.667,234.667,74.667z M234.667,341.333c-58.88,0-106.667-47.787-106.667-106.667S175.787,128,234.667,128s106.667,47.787,106.667,106.667S293.547,341.333,234.667,341.333z"/></svg></button>
										<button class="dashboard__edit-note mr-3" @click="editNote(note)" title="Edit note"><svg viewBox="0 0 488.471 488.471"><path d="m166.093 240.214h88.205v194.288h-88.205z" transform="matrix(.707 -.707 .707 .707 1.415 9.959)"/><path d="m245.547 105.541-245.547 245.547v137.382h137.382l245.548-245.547z"/></svg></button>
										<button class="dashboard__download-note mr-3" @click="downloadNote(note)" title="Download note"><svg viewBox="0 0 512 512"><path d="M382.56,233.376C379.968,227.648,374.272,224,368,224h-64V16c0-8.832-7.168-16-16-16h-64c-8.832,0-16,7.168-16,16v208h-64c-6.272,0-11.968,3.68-14.56,9.376c-2.624,5.728-1.6,12.416,2.528,17.152l112,128c3.04,3.488,7.424,5.472,12.032,5.472c4.608,0,8.992-2.016,12.032-5.472l112-128C384.192,245.824,385.152,239.104,382.56,233.376z"/><path d="M432,352v96H80v-96H16v128c0,17.696,14.336,32,32,32h416c17.696,0,32-14.304,32-32V352H432z"/></svg></button>
										<button class="dashboard__delete-note" @click="deleteNote(note)" title="Delete note"><svg viewBox="0 0 515.556 515.556"><path d="m64.444 451.111c0 35.526 28.902 64.444 64.444 64.444h257.778c35.542 0 64.444-28.918 64.444-64.444v-322.222h-386.666z"/><path d="m322.222 32.222v-32.222h-128.889v32.222h-161.111v64.444h451.111v-64.444z"/></svg></button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>	
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import Folder from "@/components/Folder";
import {
  GLOBAL_CHANGE_SECTION,
  FETCH_FOLDERS,
  FOLDER_CREATE,
  // FOLDER_UNSET_CURRENT,
  FETCH_NOTES,
  NOTE_CREATE,
  NOTE_UPDATE,
  NOTE_DELETE,
  NOTE_DOWNLOAD
} from "@/store/actions.type";

export default {
	name: 'Dashboard',
	components: {
		Folder
	},
	data() {
		return {
			deleteFolderSlug: null,
			selectedNotes: []
		}
	},
	methods: {
		getTaxonomyLabel(taxonomyId) {
      // for (var i = 0; i <= this.taxonomies.length; i++) {
      //   if(this.taxonomies[i].tax_id == taxonomyId) {
      //     return this.taxonomies[i].label;
      //   }
      // }
      return this.taxonomiesNames[taxonomyId];
    },
		getMoreTaxonomiesLabels(note) {
			let taxonomiesList = note.taxonomies;
			let taxonomiesHTML = '';
			for (var i = 1; i <= taxonomiesList.length - 1; i++) {
				if(i > 1) {
					taxonomiesHTML = taxonomiesHTML + ', ';
				}
				taxonomiesHTML = taxonomiesHTML + this.getTaxonomyLabel(taxonomiesList[i]);
			}
			return taxonomiesHTML;
		},
		goToFolderTrash() {
			this.$router.push({
				name: 'Trash',
				params: {
					type: 'folder',
					folder: this.currentFolder
				}
			});
		},
		goToNoteTrash() {
			this.$router.push({
				name: 'Trash',
				params: {
					type: 'note',
					id: this.currentFolder.folder_id,
					folder: this.currentFolder
				}
			});
		},
		createFolder() {

			Swal.fire({
				title: 'Add folder',
				input: 'text',
				inputAttributes: {
					autocapitalize: 'off'
				},
				showCancelButton: true,
				confirmButtonText: 'Add',
				showLoaderOnConfirm: true,
				preConfirm: (folderTitle) => {
					if(folderTitle == '') {
						return Swal.showValidationMessage(
							"Type folder name"
						)
					}
					let folderData = new FormData();
					folderData.set('folder_title', folderTitle);

					return this.$store.dispatch(FOLDER_CREATE, folderData);
				},
				allowOutsideClick: () => !Swal.isLoading()
			}).then((response) => {
				if(!response.dismiss) {
					if(response.value.error) {
						Swal.fire(
							'Error!',
							response.value.error.message,
							'error'
						)
					} else {
						Swal.fire(
							'Created!',
							'Your folder has been created.',
							'success'
						)
					}
				}
			});

			// let folderData = new FormData();
			// folderData.set('folder_title', folderTitle);

			// this.$store.dispatch(FOLDER_CREATE, folderData);

			// this.folderTitle = null;
			// this.showNewFolderForm = false;
		},
		getNotes(folder) {
			this.$store.dispatch(FETCH_NOTES, folder);
		},
		createNote() {

			Swal.fire({
				title: 'Add Note',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Add',
        showLoaderOnConfirm: true,
        preConfirm: (noteTitle) => {
					if(noteTitle == '') {
            return Swal.showValidationMessage(
              "Type note name"
            )
          }
          let noteData = new FormData();
          noteData.set('note_title', noteTitle);

          let folderData = {
            'folder_title': this.currentFolder.folder_title
          }
          noteData.set('folder', JSON.stringify(folderData));

          let payload = {
            'folder': this.currentFolder,
            'note': noteData
          }

          return this.$store.dispatch(NOTE_CREATE, payload);
				},
				allowOutsideClick: () => !Swal.isLoading()
			}).then((response) => {
				if(!response.dismiss) {
					if(response.value.error) {
						Swal.fire(
							'Error!',
							response.value.error.message,
							'error'
						)
					} else {
						this.selectedNote = response.value;
						Swal.fire(
							'Created!',
							'Your note has been created.',
							'success'
						)
					}
				}
			});
		},
		editNote(note) {

			let vm = this;

      Swal.fire({
        title: 'Rename note',
        input: 'text',
        inputValue: note.note_title,
        inputAttributes: {
          autocapitalize: 'off',
        },
        showCancelButton: true,
        confirmButtonText: 'Rename',
        showLoaderOnConfirm: true,
        preConfirm: (noteTitle) => {
          if(noteTitle == '') {
            return Swal.showValidationMessage(
              "Type note name"
            )
          }

          let noteData = new FormData();
          noteData.set('note_title', noteTitle);

          let payload = {
            'note': note,
            'folder': vm.currentFolder,
            'noteData': noteData
          }

          return vm.$store.dispatch(NOTE_UPDATE, payload);
        }
      }).then((response) => {
        if(!response.dismiss) {
          Swal.fire(
            'Updated!',
            'Your note has been updated.',
            'success'
          )
        }
      });

		},
		deleteNote(note) {

			let vm = this;

			Swal.fire({
				title: 'Move to trash',
				text: "Are you sure you want to move this item to the trash?",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Yes, move it!'
			}).then((response) => {
				if (response.value) {

					let payload = {
						'folder': vm.currentFolder,
						'note': note
					};
					vm.$store.dispatch(NOTE_DELETE, payload);

					Swal.fire({
						title: 'Moved to trash!',
						text: 'Your item has been moved to the trash.',
						icon: 'success'
					}).then(() => {
						vm.getNotes(vm.currentFolder);
						vm.selectedNotes = [];
					});
				}
			}); 

		},
		deleteNotes() {

			let vm = this;

			if(vm.selectedNotes.length) {
				Swal.fire({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonText: 'Yes, delete it!'
				}).then((result) => {
					if (result.value) {

						vm.selectedNotes.forEach(function(note) {
							let payload = {
								'folder': vm.currentFolder,
								'note': note
							};
							vm.$store.dispatch(NOTE_DELETE, payload);
						});

						Swal.fire({
							title: 'Deleted!',
							text: 'Your notes has been deleted.',
							icon: 'success'
						}).then(() => {
							// Prendo le note solo dopo il click swal, per aggiungere un delay alla fetch
							// @ToDo aggiungere una promise per assicurarci di fare fetch sulle notes solo dopo che sono terminate
							// tutti i dispatch di note_delete
							vm.getNotes(vm.currentFolder);
							vm.selectedNotes = [];
						});
					}
				});
			} else {
				Swal.fire(
					'Nothing to delete!',
					'You must select at least one note.',
					'warning'
				);
			}		
			
		},
		goToNote(note) {
			this.$router.push({
				name: 'Note',
				params: {
					slug: note.note_slug,
					noteTitle: note.note_title,
					folder: this.currentFolder
				}
			});
		},
		downloadNote(note) {
			let payload = {
				id: note.note_id,
				title: note.note_title
			}
			this.$store.dispatch(NOTE_DOWNLOAD, payload)
			.then((response) => {
				if(response == 'no-subnotes') {
					Swal.fire(
						'Nothing to download!',
						'The selected note has no subnotes.',
						'warning'
					);
				}
			});
		}
	},
	computed: {
		...mapGetters(["isAuthenticated", "section", "user", "taxonomies", "folders", "currentFolder", "notes", "taxonomiesNames"]),
		selectAllNotes: {
			get: function() {
				if(this.notes) {
					if(this.notes.length) {
						if(this.selectedNotes.length == this.notes.length) {
							return true;
						}
					}
				}
				return false;
			},
			set: function(value) {
				var selected = [];

        if (value) {
          this.notes.forEach(function(note) {
            selected.push(note);
          });
        }
        this.selectedNotes = selected;
			}
		}
	},
	mounted() {
		if (!this.isAuthenticated) {
			this.$router.push({ name: "Login" });
			return;
		}

    if(this.section != 'search') {
      this.$store.dispatch(GLOBAL_CHANGE_SECTION, 'search');
    }

		// this.$store.dispatch(FOLDER_UNSET_CURRENT);

		// Ha davvero senso che facciamo una fetch sola qui e ora?
		// Abbiamo due alternative:
		// 1. Fetch ad ogni passaggio dalla dashboard, risultando quindi in un gran numero di chiamate potenzialmente inutili
		// 2. Fetch dopo il login, quindi da lanciare sulla view Login
		//	 2a. Potrebbe non aver senso ques'ultima ipotesi, può verificarsi che il token è presente in localStorage ma gli state non sono popolati
		//       di conseguenza saltiamo il processo di login e l'app va in errore
		// if(Object.keys(this.folders).length === 0) {
		// 	this.$store.dispatch(FETCH_FOLDERS);
		// }

		this.$store.dispatch(FETCH_FOLDERS);

		if(this.currentFolder) {
			this.getNotes(this.currentFolder);
		}
	}
}
</script>

<style lang="scss">

.dashboard {

	&__button {
		margin: 0;
		padding: 0;
		border: 0;
		background: none;

		svg {
			width: rem(28px);
			height: rem(28px);
			transition: fill .3s ease;
		}

		&:focus {
			outline: none;
		}
	}

	&__new-folder,
	&__to-trash {

		svg {
			fill: $color-genoa;
		}

		&:hover {

			svg {
				fill: $color-java;
			}
		}
	}

	&__delete-notes {

		svg {
			width: rem(20px);
			height: rem(20px);
			// fill: #cbcbcb;
			fill: $color-genoa;
		}
		
		&:hover {

			svg {
				fill: $color-java;
			}
		}
	}

	&__create-note {

		svg {
			width: rem(28px);
			height: rem(28px);
			// fill: #cbcbcb;
			fill: $color-genoa;
		}
		
		&:hover {

			svg {
				fill: $color-java;
			}
		}
	}

	&__note-table.table {
		font-size: rem(14px);
		color: $color-abbey;
		font-weight: 400;
		margin-bottom: 0;

		tbody {
			font-family: $font-family-roboto;
		}
	}

	&__note-name {
		font-family: $font-family-montserrat;
		color: #000;
	}

	&__view-note,
	&__edit-note,
	&__download-note,
	&__delete-note {
		margin: 0;
		padding: 0;
		border: 0;
		background: none;

		&:focus {
			outline: none;

			svg {
				fill: $color-genoa;
			}
		}

		svg {
			width: rem(16px);
			height: rem(16px);
			fill: $color-genoa;
			transition: fill .3s ease;

			&:hover {
				fill:$color-java;
			}
		}
	}
}

</style>